"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundError = void 0;
const ResponseError_1 = require("./ResponseError");
class NotFoundError extends ResponseError_1.ResponseError {
    constructor(message = "Not found error.") {
        super("Not found error.", message, 404);
    }
}
exports.NotFoundError = NotFoundError;
//# sourceMappingURL=NotFoundError.js.map